import { HeartPulse, Shield } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { GhlCalendar } from './GhlCalendar';
import { PhoneButton } from './PhoneButton';
import { SectionTitle } from './PageHero';
import { CALENDARS } from '../../lib/site';

const TRACKS = [
  { value: 'medicare', label: 'Medicare & health coverage', Icon: HeartPulse, phone: 'medicare', id: 'turning65medicarehelp_booking', title: 'Medicare consultation' },
  { value: 'retirement', label: 'Life insurance & retirement income', Icon: Shield, phone: 'financial', id: 'retirement_planning_booking', title: 'Life insurance & retirement consultation' },
];

const TRIGGER = 'rounded-full px-5 py-3 text-sm font-semibold text-slate-300 data-[state=active]:bg-orange-500 data-[state=active]:text-white data-[state=active]:shadow-lg gap-2';

export const DualBooking = ({ testid, title = 'Book your consultation', sub }) => (
  <section id="book" style={{ scrollMarginTop: 96 }} data-testid={testid} className="max-w-6xl mx-auto px-5 lg:px-8 py-20">
    <SectionTitle kicker="Schedule" title={title} sub={sub || 'Choose the topic you want to talk about. Each one has its own calendar and phone line.'} />
    <Tabs defaultValue="medicare">
      <TabsList className="bg-white/5 border border-white/10 rounded-full p-1.5 h-auto flex flex-wrap justify-start w-fit mb-8">
        {TRACKS.map((t) => (
          <TabsTrigger key={t.value} value={t.value} data-testid={`${testid}-tab-${t.value}`} className={TRIGGER}>
            <t.Icon className="w-4 h-4" /> {t.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {TRACKS.map((t) => (
        <TabsContent key={t.value} value={t.value} className="mt-0 space-y-6">
          <PhoneButton type={t.phone} size="lg" testid={`${testid}-${t.value}-phone`} />
          <GhlCalendar src={CALENDARS[t.value]} id={t.id} title={t.title} testid={`${testid}-${t.value}-calendar`} />
        </TabsContent>
      ))}
    </Tabs>
  </section>
);
